/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { throttle } from "lodash";
import { useCallback, useState } from "react";

/**
 * Will automatically update the component at most every given interval.
 * TipTap's useEditor function fires on every single update which unnecessarily
 * grinds performance to a standstill.
 * @param {number} delay - The interval to wait
 * @returns 
 */
export function useThrottledUpdate (delay = 170) {
    
    // eslint-disable-next-line no-unused-vars
    const [version, setVersion] = useState(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledUpdate = useCallback(
        throttle(
            function () {
                setVersion((prevVersion) => prevVersion + 1);
            },
            delay,
            {
                // ensure that we are getting the last event
                trailing: true,

                // ensure that we are firing on the immediate event
                leading: true
            }
        ),
        [delay]
    );

    return throttledUpdate;
}
